import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ProofActions = ({ onEdit, onDelete, onClose }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    onDelete();
    setShowDeleteConfirm(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <Button
          variant="outline"
          iconName="Edit"
          iconPosition="left"
          onClick={onEdit}
          className="flex-1 sm:flex-initial"
        >
          수정
        </Button>
        <Button
          variant="destructive"
          iconName="Trash2"
          iconPosition="left"
          onClick={handleDeleteClick}
          className="flex-1 sm:flex-initial"
        >
          삭제
        </Button>
        <Button
          variant="secondary"
          iconName="X"
          iconPosition="left"
          onClick={onClose}
          className="flex-1 sm:flex-initial sm:ml-auto"
        >
          닫기
        </Button>
      </div>

      {showDeleteConfirm && (
        <div className="fixed inset-0 z-dialog bg-background/95 backdrop-blur-sm flex items-center justify-center p-4">
          <div
            className="bg-card rounded-lg shadow-gaming-lg p-6 md:p-8 max-w-md w-full"
          >
            <div className="flex items-start space-x-4 mb-6">
              <div className="flex-shrink-0 w-12 h-12 bg-destructive/20 rounded-md flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                  증명 삭제 확인
                </h3>
                <p className="text-sm text-muted-foreground">
                  이 증명을 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며, 모든 데이터가 영구적으로 삭제됩니다.
                </p>
              </div>
            </div>
            <div className="flex items-center justify-end space-x-3">
              <Button variant="outline" onClick={handleCancelDelete}>
                취소
              </Button>
              <Button variant="destructive" onClick={handleConfirmDelete}>
                삭제
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProofActions;